import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import routesConfig from "./routesConfig";
import Layout from "./components/layout";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Unauthorized from "./pages/Unauthorized";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/AdminDashboard";
import AddNewUser from "./pages/addNewUser";
import AddIncomingTab from "./pages/IncomingTab";
import IncomingPreview from "./pages/IncomingPreview";
import AddFreeNowInfo from "./pages/addFreenow";
import EditFreeNowInfo from "./pages/freenowInfo";
import adminUsers from "./pages/admin/users"

import adminDriverRaport from "./pages/admin/driverRaport"
import adminDriversDebts from "./pages/admin/driversDebts"
import DriverDebtDetails from "./pages/admin/DriverDebtDetails"; // імпортуємо сторінку деталей
import DriverExtraFunds from "./pages/admin/extraFunds";
import DriverExtraFundsEdit from "./pages/admin/extraFundsEdit";
import CashStats from "./pages/admin/cashStats";
import Instructions from "./pages/instructions";
import editSourceData from "./pages/admin/editSourceData";
import weeklyStats from './pages/admin/weeklyStats';
import UserSettings from "./pages/userSettings";
import adminRaports from "./pages/admin/adminReports";
import siteSettings from "./pages/admin/settings";
import UserDashboard from "./pages/user/userDashboard";
import UserRaport from "./pages/user/userReportDetails";

import CookieConsent from "./components/CookieConsent";
import PrivacyPolicy from "./pages/privacyPolicy";


import "./i18n";

const componentMap = {
  Dashboard,
  Admin,
  AddNewUser,
  AddIncomingTab,
  IncomingPreview,
  AddFreeNowInfo,
  EditFreeNowInfo,
  adminUsers,
  adminDriverRaport,
  adminDriversDebts,
  DriverDebtDetails,
  DriverExtraFunds,
  DriverExtraFundsEdit,
  CashStats,
  Instructions,
  editSourceData,
  weeklyStats,
  UserSettings,
  adminRaports,
  siteSettings,
  UserDashboard,
  UserRaport,
  
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Публічні маршрути */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />


          

          {/* Дефолтний маршрут */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            {routesConfig.map(({ path, component, roles }) => {
              const Component = componentMap[component];
              return (
                <Route
                  key={path}
                  path={path}
                  element={
                    <ProtectedRoute allowedRoles={roles}>
                      <Component />
                    </ProtectedRoute>
                  }
                />
              );
            })}
          </Route>

        </Routes>
        <CookieConsent />

      </Router>
    </AuthProvider>
  );
}

export default App;
